import MFELink from '@components/MFELink/MFELink';
import { useAccountContext } from '@context/AccountContext';
import { t } from '@lingui/macro';
import PermissionService from '@services/permission.service';
import { DropdownButton, LocationIcon, Menu, MenuItem, MenuItemIcon, MenuItemText, ProfileIcon, SignOutIcon, } from '@onsolve/onsolve-ui-components';
import React, { useMemo, useState } from 'react';
import styles from './ProfileDropdown.module.scss';
import jwtService from 'services/jwt.service';
import { DataDogMask } from '@components/DatadogMask/DatadogMask';
import AuthService from '@services/auth.service';
let username;
const ProfileDropdown = () => {
    const { loggedInUser: { username: usernameFromContext = '', firstName = '' } = {} } = useAccountContext();
    const { canViewOpV3, canViewMyProfile, canViewCheckIn, canViewAssetDataStore, canEditMyProfile, canEditContacts } = new PermissionService().permissions;
    const firstInitial = firstName.charAt(0).toUpperCase();
    const userId = canViewAssetDataStore() ? jwtService.getUserAssetId() : jwtService.getUserUuid();
    const [isOpen, setDropdownOpen] = useState(false);
    const redirectLink = useMemo(() => {
        if (canEditMyProfile() && !canEditContacts()) {
            return `/contacts/profile/${userId}/overview`;
        }
        return `/contacts/${userId}/overview`;
    }, [canEditMyProfile, canEditContacts]);
    username = canViewOpV3() && canViewAssetDataStore() ? jwtService.getUsername() : usernameFromContext;
    //eslint-disable-next-line @typescript-eslint/no-unused-vars
    const handleDropdownToggle = (e) => {
        setDropdownOpen(!isOpen);
    };
    const handleOnKeyDown = (e) => {
        if (e.code === 'Enter') {
            AuthService.signOut();
        }
    };
    const dropdownProps = {
        'aria-label': t `Open ${firstName} profile menu`,
        className: 'text-white p-2 p-md-0',
        color: 'transparent',
        isOpen: isOpen,
        onToggle: handleDropdownToggle,
        onKeyDown: handleDropdownToggle,
        showToggle: false,
        title: (<div className={`${styles.user_config} bg-white`}>
                <DataDogMask>
                    <span>{firstInitial}</span>
                </DataDogMask>
            </div>),
    };
    return (<>
            <DropdownButton {...dropdownProps}>
                <Menu>
                    {canViewMyProfile() && (<>
                            <MenuItem id="my-information" onClick={handleDropdownToggle}>
                                <MFELink to={redirectLink} className={styles.menuItemLink} requiresJWT={false}>
                                    <MenuItemIcon>
                                        <ProfileIcon />
                                    </MenuItemIcon>
                                    <MenuItemText>
                                        {t `My Information`}
                                        <DataDogMask>
                                            <div>{t `Signed in as: ${username}`}</div>
                                        </DataDogMask>
                                    </MenuItemText>
                                </MFELink>
                            </MenuItem>
                            <MenuItem variant="divider" disabled/>
                        </>)}
                    {canViewMyProfile() && canViewCheckIn() && (<>
                            <MenuItem variant="divider" disabled/>

                            <MFELink to={'/check-in'} className={styles.menuItemLink} requiresJWT={false}>
                                <MenuItem id="check-in" className={styles.menuItem}>
                                    <MenuItemIcon>
                                        <LocationIcon />
                                    </MenuItemIcon>
                                    <MenuItemText>{t `Check In`}</MenuItemText>
                                </MenuItem>
                            </MFELink>

                            <MenuItem variant="divider" disabled/>
                        </>)}
                    <MenuItem id="sign-out" aria-label={t `Sign Out`} onClick={() => AuthService.signOut()} onKeyDown={handleOnKeyDown}>
                        <MenuItemIcon>
                            <SignOutIcon />
                        </MenuItemIcon>
                        <MenuItemText>{t `Sign Out`}</MenuItemText>
                    </MenuItem>
                </Menu>
            </DropdownButton>
        </>);
};
export default ProfileDropdown;
